const Requests = require('requests').Requests;
const notificationsModule = require('data/service/notifications');
const deps = [require('ngreact').name, notificationsModule.name];

const mod = angular.module('bench.ui.requests', deps);

mod.directive('blRequests', [
  'reactDirective',
  'NotificationsService',
  '$rootScope',
  function (reactDirective, NotificationsService, $rootScope) {
    // need to make sure the rootScope digests after notification
    const notify = (message, options) => {
      const id = NotificationsService.add(message, options);
      $rootScope.$applyAsync();
      return id;
    };

    return reactDirective(Requests, ['clientId'], {}, { notify });
  },
]);

module.exports = mod;
